export default __webpack_public_path__ + "static/media/thumbnail.f68bc5f6.png";